import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { isNullOrUndefined } from '../helper/sla-util.helper';
import { DatePipe } from '../pipes/date.pipe';
import { NumberPipe } from '../pipes/number.pipe';

@Injectable({
    providedIn: 'root',
})
export class TranslateDeepService {

    public value: string = '';

    constructor(
        private myTranslateService: TranslateService,
    ) {
    }

    public instant(key: string, ...args: any[]): any {
        if (!key || key.length === 0) {
            return key;
        }
        // interpolate params
        const interpolateParams: any = this.interpolate(args);

        let res: any = this.myTranslateService.instant(key);
        res = this.translateDeep(res, interpolateParams, []);
        this.value = res !== undefined ? res : key;
        return this.value;
    }

    public translateDeep(key: string, interpolateParams: any, previousKeys: string[] = []): string {
        if (previousKeys.indexOf(key) === -1) {
            previousKeys.push(key);
            const templateMatcher: RegExp = /{{\s?([^{}]*)\s?}}/g;
            key = key.replace(templateMatcher, (substring: string, b: string) => {
                let r: string;
                if (b.indexOf('|') > -1) {
                    r = this._getPipeValue(interpolateParams, b.trim(), previousKeys);
                } else {
                    r = this._getValue(interpolateParams, b.trim());
                }
                return !isNullOrUndefined(r) ? r : substring;
            });
            return key;
        } else {
            console.error('Endless loop detected:', `${JSON.stringify(previousKeys)} -> ${key}`);
            return key;
        }

    }

    public interpolate(args: any[]): any {
        let interpolateParams: any;
        if (!isNullOrUndefined(args[ 0 ]) && args.length) {
            if (typeof args[ 0 ] === 'string' && args[ 0 ].length) {
                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
                const validArgs: string = args[ 0 ]
                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
                try {
                    interpolateParams = JSON.parse(validArgs);
                } catch (e) {
                    throw new SyntaxError(`Wrong parameter in TranslatePipe. Expected a valid Object, received: ${args[ 0 ]}`);
                }
            } else if (typeof args[ 0 ] === 'object' && !Array.isArray(args[ 0 ])) {
                interpolateParams = args[ 0 ];
            }
        }
        return interpolateParams;
    }

    private _getValue(target: any, key: string): any {
        const keys: string[] = key.split('.');
        key = '';
        do {
            key += keys.shift();
            if (!isNullOrUndefined(target) && !isNullOrUndefined(target[ key ]) && (typeof target[ key ] === 'object' || !keys.length)) {
                target = target[ key ];
                key = '';
            } else if (!keys.length) {
                target = undefined;
            } else {
                key += '.';
            }
        } while (keys.length);
        return target ? this.myTranslateService.instant(target.toString()) : target;
    }

    private _doPipe(pipeData: any[], index: number, interpolatedParams: any, previousKeys: string[]): string {
        const pipe: any = pipeData[ index ];
        let valueString: string;
        const pipeName: string = pipe.pipe[ 0 ];

        // Pipe Definitionen
        if (pipeName === 'datePipe') {
            const datePipe: DatePipe = new DatePipe(this.myTranslateService);
            valueString = datePipe.transform(pipe.value, pipe[ 1 ], pipe[ 2 ], pipe[ 3 ], pipe[ 4 ]);
            // valueString = formatDate(pipe.value, pipe.pipe[2], pipe.pipe[1],  pipe.pipe[4] ? 'UTC' : pipe.pipe[3]);
        } else if (pipeName === 'numberPipe') {
            const numberPipe: NumberPipe = new NumberPipe(this.myTranslateService);
            valueString = numberPipe.transform(pipe.value, pipe[ 1 ], pipe[ 2 ]);
            // valueString = formatNumber(pipe.value, pipe.pipe[2], pipe.pipe[1]);
        } else if (pipeName === 'translate') {
            valueString = pipe.value ? this.translateDeep(this.myTranslateService.instant(pipe.value.toString()), interpolatedParams, previousKeys) : null;
        } else {
            return null;
        }

        if (pipeData[ index + 1 ]) {
            pipeData[ index + 1 ].value = valueString;
            return this._doPipe(pipeData, index + 1, interpolatedParams, previousKeys);
        } else {
            return valueString;
        }

    }

    private _getPipeValue(interpolateParams: any, pipeData: string, previousKeys: string[]): string {
        const valueKey: string = pipeData.split('|')[ 0 ].trim();
        const pipes: string[] = pipeData.split('|').slice(1);
        const allPipes: any[] = [];
        for (const pipe of pipes) {
            const pipeParams: string[] = pipe.split(':');
            const resultPipeData: any[] = [];
            pipeParams.forEach((p: any) => {
                resultPipeData.push(p.replace(/'/g, '').trim());
            });
            allPipes.push({ value: this._getValue(interpolateParams, valueKey), pipe: resultPipeData });
        }
        return this._doPipe(allPipes, 0, interpolateParams, previousKeys);
    }

}
